/******/ (() => { // webpackBootstrap
    var __webpack_exports__ = {};
    Shopify.theme.jsUpcomming = {
      init: function ($section) {
        var $upcommingtimer = $section.find('[data-date]');
        // Loop through each element
        $upcommingtimer.each(function(index, element) {
            var targetDate = new Date($(element).data('date'));   
            reverse_timer(targetDate,element)      
            var timer = setInterval(function() {
              reverse_timer(targetDate,element)}, 60000);            
        });
        function reverse_timer(targetDate,element) {
            var currentDate = new Date();
            var difference = targetDate - currentDate;
            // console.log(difference);
            if (difference < 0) {
                clearInterval(timer); // Stop the timer
                $(element).find(".days").text("0");
                $(element).find(".hours").text("0");
                $(element).find(".mins").text("00");
                return;
            }

            // Calculate days, hours, minutes, and seconds
            var days = Math.floor(difference / (1000 * 60 * 60 * 24));
            var hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
            // var seconds = Math.floor((difference % (1000 * 60)) / 1000);
            // console.log(days,hours,minutes,seconds);
            $(element).find(".days").text(days);
            $(element).find(".hours").text(hours);
            $(element).find(".mins").text(minutes);
            // Update the countdown element with the remaining time
        }
      },
      unload: function ($section) {
      }
    }
  
    /******/
  })()
    ;